import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerCryptogramTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  CryptogramDefinition,
  CryptogramProgress,
  CryptogramSolution,
  CryptogramSubmission,
} from "./types";

registerCryptogramTranslations(i18n);

/** `localFeedback` flags a plain letter written under two cipher letters; nothing else. */
export const cryptogramModule: PuzzleTypeModule<
  CryptogramDefinition,
  CryptogramSubmission,
  CryptogramProgress,
  CryptogramSolution
> = {
  key: "cryptogram",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
